import axios from 'axios'
import { environment } from '../config.env';

const ENDPOINT_DOMAIN = process.env.REACT_APP_ENDPOINT_DOMAIN || environment.endpoint_domain || ''

axios.defaults.baseURL = ENDPOINT_DOMAIN;

// axios.defaults.headers.common['Authorization'] = localStorage.getItem('pg_access_token');

export function getRequestPermission(status, page, number_per_page) {
    return new Promise(resolve => {
        const path = '/api/v1/patient/permission/getRequestPermission'
        let body = {
            "status": status,
            "page": page,
            "number_per_page": number_per_page
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(path, body, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}

export function getPermission(permission_id) {
    return new Promise(resolve => {
        const path = '/api/v1/patient/permission/getPermission'
        let body = {
            "permission_id": permission_id
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(path, body, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}


export function acceptCredentialToken(permission_id, accept, every_time, some_time) {
    return new Promise(resolve => {
        const path = '/api/v1/patient/permission/acceptCredentialToken'
        let body = {
            "permission_id": permission_id,
            "accept": accept,
            "access_data_every_time": every_time,
            "access_data_some_time": some_time,
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(path, body, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}


// ยืนยัน token จาก Mobile App → ได้ viewer token ของเรา
export function authenticateViewerToken(appToken) {
    return new Promise(resolve => {
        const path = '/api/v2/viewer/authenticate';
        const header = { 'Content-Type': 'application/json' };
        axios.post(path, { token: appToken }, { headers: header }).then(res => {
            resolve(res);
        }).catch(() => {
            resolve(false);
        });
    });
}

// ดึงข้อมูลผลตรวจโดยใช้ viewer token (สำหรับ Mobile App WebView)
export function getLabInformationByViewerToken(viewerToken) {
    return new Promise(resolve => {
        const path = '/api/v2/viewer/lab-information';
        const header = {
            'Content-Type': 'application/json',
            'viewer-token': viewerToken,
        };
        axios.get(path, { headers: header }).then(res => {
            resolve(res);
        }).catch(() => {
            resolve(false);
        });
    });
}

//lab ทั้งหมด paitent
export function getLabInformation() {
    return new Promise(resolve => {
        const path = '/api/v1/patient/lab/getLabInformation'
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.get(path, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}

//lab ยีนแพ้ยา
export function getDrugAllergyGene() {
    return new Promise(resolve => {
        const path = '/api/v1/patient/lab/getDrugAllergyGene'
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.get(path, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}

//lab ยีนย่อยสลาย
export function getDrugDegradingGene() {
    return new Promise(resolve => {
        const path = '/api/v1/patient/lab/getDrugDegradingGene'
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.get(path, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}

export function postUpdatePermission(permission_everytime, permission_sometime) {
    return new Promise(resolve => {
        const path = '/api/v1/patient/permission/updatePermission'
        let body = {
            "access_data_every_time": permission_everytime,
            "access_data_some_time": permission_sometime
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(path, body, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}


export function getQuestionnaire(page, number_per_page) {
    return new Promise(resolve => {
        const path = '/api/v1/patient/questionnaire/getQuestionnaire'
        let body = {
            "page": page,
            "number_per_page": number_per_page
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(path, body, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}

export function getActivePermissionPatient() {
    return new Promise(resolve => {
        const url = '/api/v1/patient/permission/getActivePermission'
        let header = {
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export function updateMohPromtIAL(code) {
    return new Promise(resolve => {
        let url = '/api/v1/auth/updateMohPromtIAL'
        let body = {
            "code": code
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}

//verify by thai id
export function getOauthVerifyIdentityThaiID(role){
    return new Promise(resolve => {
        const path = `/api/v1/patient/verify-identity/getOauthVerifyIdentityThaiID/web/${role}`

        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.get(path, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            // //console.log(error)
        })
    })
}

export function verifyThaiDWithRoleUID(code, roleName, uid){
    return new Promise(resolve => {
        let url = `/api/v1/uplevel/thaid/verifyThaiD/web/${roleName}`
        let body = {
            "code": code,
            "role": roleName,
            "uid": uid
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}